<template>
  <BaseBody>
    <BaseTopBar>
      <BaseTopBarContent className="left">
        {{ $t('sidebar.payslipcondition') }} > {{ $t('sidebar.all') }}
      </BaseTopBarContent>
    </BaseTopBar>
    <BaseContent :loading="loading">
      <base-table
        :pagination="pagination"
        @onPageChange="handlePageChange"
      >
        <template #thead>
          <thead>
            <tr>
              <th>{{ $t('apps.payroll.message.name') }}</th>
              <th style="width: 20%;">{{ $t('apps.payroll.message.conditiontype') }}</th>
              <th style="width: 20%;">{{ $t('apps.payroll.message.calculationtype') }}</th>
              <th
                style="width: 14%;"
                class="text-center">{{ $t('apps.payroll.label.autoapplyshort') }}</th>
            </tr>
          </thead>
        </template>
        <template #tbody>
          <tbody>
            <tr>
              <td
                v-if="empty"
                colspan="4"
                class="text-center">
                {{ $t('message.notfounddata') }}
              </td>
            </tr>
            <tr
              v-for="(item, index) in data"
              :key="index"
            >
              <td>
                <router-link
                  :to="{
                    name: 'PaySlipConditionEdit',
                    query: {
                      id: item.conditionId,
                      name: item.name,
                    }
                }">
                  {{ item.name }}
                </router-link>
              </td>
              <td>
                {{ $t(PAYSLIP_CONDITION_TRANSLATE[item.type]) }}
              </td>
              <td>
                {{
                  item.isIncrement ?
                    $t('apps.payroll.message.increment') :
                    $t('apps.payroll.message.decrement')
                }}
              </td>
              <td class="text-center">
                <i
                  v-if="item.autoApplyNewEmp"
                  class="fas fa-check"/>
              </td>
            </tr>
          </tbody>
        </template>
      </base-table>
    </BaseContent>
  </BaseBody>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { PAYSLIP_CONDITION_TRANSLATE } from '@/helpers/enum'
import tablePaginateMixin from '@/mixins/tablePaginate'
import sidebarModule from './../../sidebarModule'
import userPermissionMixin from '@/mixins/userPermission'

export default {
  mixins: [tablePaginateMixin, userPermissionMixin],

  data () {
    return {
      PAYSLIP_CONDITION_TRANSLATE,
      loading: true,
      query: {
        page: this.$route.query.page || 1,
      },
    }
  },

  computed: {
    ...mapState('payroll', {
      data: 'conditionList',
    }),
  },

  watch: {
    $route (to, from) {
      if (!Object.keys(to.query).length) {
        this.query.page = 1
        this.fetchData()
      }
    },
  },

  created () {
    this.fetchData()
  },

  beforeMount () {
    this.initPage({
      section: 'app',
      name: this.$t('app.payroll.title'),
      current: {
        app_name: 'payroll',
        app_id: 14,
        module_id: 3,
      },
    })
    sidebarModule.init(this.getObject(require('../sidebar.json')), {
      sidebarAtIdx: 2,
      submenuAtIdx: 0,
    })
  },

  destroyed () {
    this.leavePage(this.$Progress, [])
  },

  methods: {
    ...mapActions('payroll', {
      'getConditionList': 'getConditionList',
    }),
    async fetchData () {
      this.updateUrl()
      this.loading = true
      await this.getConditionList({
        page: this.query.page,
        limit: this.$store.state.app.limitRowsPerpage,
      })
      this.loading = false
      this.showFinish(this.$Progress)
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/apps/payroll/condition/List.vue